import React from "react";

import {
  MFAContainer,
} from "../../../styled";
import {MAX_CODE_LENGTH} from "../../../constants";
import {Form, Header, Icon} from "semantic-ui-react";
import {ClickableText, CustomDivider, CustomGrid} from "../../../../components/custom-common";


const VerifyRenderItem = ({code, validationErrors, isDisabled, loading, codeHandler, validateMfaCode, validateForm, isCodeEmailVerified, validateMfaCodeError }) => {
  return (
    <>
      <Form.Field className={'mfaVerifyCode noVerticalMargin'} error={validationErrors}>
        <Form.Input className={'noVerticalMargin'}
          label={"6-digit authentication code"}
          type="text"
          name="authenticatorCode"
          id="authenticatorCode"
          value={code}
          onChange={(e) => codeHandler(e)}
          maxLength={MAX_CODE_LENGTH}
          error={(validationErrors || !!validateMfaCodeError)}
          required
          disabled={isDisabled}
          onBlur={(e) => validateForm(code)}
        />
      </Form.Field>
      {isCodeEmailVerified &&
      (
        <p className="mfaVerified small">
          <Icon name="checkmark" size="small" className="verifiedIcon" />
          Verified
        </p>
      )}
    </>
  );
};

const AuthenticatorVerify = ({
  codeHandler,
  validationErrors,
  code,
  validateMfaCode,
  validateMfaCodeError,
  loading,
  mfaEnabled,
  changeMethodSettings,
  isMethodChanged,
  validateForm,
  addAnotherMethod,
  isCodeEmailVerified,
  goBackStepOne
}) => {

  return (
    <>
    <MFAContainer className="sectionWrapper" maxWidth={"620px"}>
      <CustomGrid>
        <CustomGrid.Row>
          <CustomGrid.Column>
            <Header as="h2" className={'noVerticalMargin'}>Enter authentication code</Header>
            <CustomDivider smaller hidden/>
            <p className={'neutral700Text'}>
              Enter the 6-digit code generated by your authenticator app to verify setup—
            </p>
          </CustomGrid.Column>
        </CustomGrid.Row>
        <CustomDivider smaller hidden/>
        <CustomGrid.Row>
          <CustomGrid.Column>
            <Form>
              <Form.Group grouped>
                      <VerifyRenderItem
                        code={code}
                        validationErrors={validationErrors}
                        isDisabled={changeMethodSettings ? isMethodChanged : (mfaEnabled && !addAnotherMethod)}
                        loading={loading}
                        codeHandler={codeHandler}
                        validateMfaCode={validateMfaCode}
                        validateForm={validateForm}
                        isCodeEmailVerified={isCodeEmailVerified}
                        validateMfaCodeError={validateMfaCodeError}
                      />

                      {validationErrors && (
                        <p className={'warningRedText smaller'}>Enter a 6-digit authentication code</p>
                      )}
                      {(validateMfaCodeError && !validationErrors) && (
                        <p className={'warningRedText smaller'}>{validateMfaCodeError}</p>
                      )}

                      {!isCodeEmailVerified && (
                          <>
                            <CustomDivider small hidden/>
                            <CustomDivider small hidden/>
                            <p className={'small'}>
                            Having trouble?&nbsp;
                              <ClickableText small onClick={goBackStepOne}>
                                Try a different method
                              </ClickableText>
                            </p>
                          </>
                      )}

              </Form.Group>
            </Form>
          </CustomGrid.Column>
        </CustomGrid.Row>
        </CustomGrid>
      </MFAContainer>
    </>
  );
};

export default AuthenticatorVerify;
